import React, { Component } from "react";
import { Button } from "react-bootstrap";
import "./Pricing.css";

export default class PricingCard extends Component {
  render() {
    return (
      <div
        className="pricing-card-container"
        style={
          this.props.recommended && {
            border: "solid 1.5px orange",
            boxShadow: "0 0 10px 0 rgba(255, 166, 0.5)",
          }
        }
      >
        {this.props.recommended && (
          <span className="recommended">Recommended</span>
        )}
        <div className="pricing-card-content">
          <div className="pricing-card-header">
            <div className="pricing-card-plan-period">{this.props.period}</div>
            <div className="pricing-card-plan-price">
              <div className="pricing-card-original-price">
                ₹{this.props.originalPrice}{" "}
              </div>

              <div className="pricing-card-discounted-price">
                <span className="pricing-card-symbol-discounted-price">₹</span>
                {this.props.discountedPrice}{" "}
                <span className="pricing-card-plan-price-period">
                  /{this.props.pricePeriod}
                </span>
              </div>
            </div>
          </div>
          <div className="pricing-card-body">
            <div className="pricing-card-plan-name">{this.props.planName}</div>
            <div className="pricing-card-button-wrapper">
              <Button
                className="pricing-card-body-button ds-btn-primary"
                variant=""
                size="md"
                onClick={() => this.props.intiatePayment(this.props.product_id)}
              >
                Subscribe!
              </Button>
              {this.props.showPaypalButton && <Button
                className="pricing-card-body-button pricing-card-paypal-button ds-btn-secondary"
                variant=""
                size="md"
                onClick={() => this.props.intiatePaypalPayment(this.props.product_id)}
              >
                Subscribe with <img className="pricing-card-button-paypal-img" alt="subscribe with paypal" src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-150px.png"></img>
              </Button>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
